import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox"];

  removeSensation(event) {
    const button = event.currentTarget;
    const sensation = button.dataset.sensation;
    const checkbox = this.checkboxTargets.find((cb) => cb.value === sensation);

    if (checkbox) {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event("change"));
    }
  }
}
